<mat-dialog-content>
  <div class="w-100 text-center px-4 py-3">
    <div *ngIf="icon == alertCustomSerasaEnum.SUCCESS" class="icon-container icon-success">
      <i class="fg fg-vuesaxlinearEssetionaltick-check"></i>
    </div>

    <div *ngIf="icon == alertCustomSerasaEnum.ERROR" class="icon-container icon-error">
      <i class="fg fg-vuesaxlinearEssetionalClose-2"></i>
    </div>

    <div *ngIf="icon == alertCustomSerasaEnum.WARN" class="icon-container icon-warning">
      <i class="fg fg-vuesaxlinearEssetionaldanger"></i>
    </div>
  </div>
  <hr />
  <mat-dialog-actions class="action w-100 pb-3 d-flex justify-content-center">
    <div class="d-flex flex-column">
      <p class="text-uppercase mb-0 title">{{ title }}</p>
      <p>{{ message }}</p>
      <div *ngIf="!!boxAlertMessage" class="box-content-message">
        <p [innerHtml]="boxAlertMessage | safeHtml"></p>
        <p *ngIf="update" class="text-orange font-16 mt-2" (click)="updateSerasa()">Clique aqui</p>
      </div>
    </div>

    <div *ngIf="!!buttonTheme && !!buttonText" class="w-100 text-center">
      <button
        class="ml-1"
        [ngClass]="{
          success: buttonTheme === alertCustomSerasaEnum.SUCCESS,
          warn: buttonTheme === alertCustomSerasaEnum.WARN,
          error: buttonTheme === alertCustomSerasaEnum.ERROR
        }"
        mat-dialog-close
      >
        {{ buttonText }}
      </button>
    </div>
  </mat-dialog-actions>
</mat-dialog-content>
